import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment, { Moment } from "moment-timezone";

import * as Type from "@interface/index";
import * as Model from "@models/index";
import * as Middleware from "@middlewares/index";
import Cookie from "@helpers/Cookie";
import { isUnSubscribeAllWebs } from "@helpers/isUnSubscribeAllWebs";

interface PropsInterface extends Type.ComponentInterface {}

interface StateInterface {
  signin: {
    csrf: string;
    remember_me: string;
    login: string;
    password: string;
  };
  isPwdShowed: boolean;
  isShowedPagePlan: boolean;
  // scheduleList: any[];
  workshopRegistrationDate: Moment;
}

class SignInPage extends React.Component<PropsInterface, StateInterface> {
  public constructor(props: PropsInterface) {
    super(props);
    this.state = {
      signin: {
        csrf: "",
        login: "",
        password: "",
        remember_me: "",
      },
      isPwdShowed: false,
      isShowedPagePlan: !!Cookie.get("isShowedPagePlan"),
      // scheduleList: this.props.Store.Schedule.list,
      workshopRegistrationDate: moment(),
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  public componentDidMount() {
    new Model.Main.Workshop().get().then((response: any) => {
      this.setState({
        workshopRegistrationDate: moment(response.data.registerStartAt).tz(
          "Europe/Moscow"
        ),
      });
    });

    document.title = "Вход" + " | " + process.env.SITE_NAME;
    this.setState({
      signin: { ...this.state.signin, login: this.props.Store.Auth.email },
    });
    this.props.Dispatch(Middleware.Ui.Footer.hide());
    // this.props.Dispatch(Middleware.Ui.Header.hide());
  }

  public componentWillUnmount() {
    this.props.Dispatch(Middleware.Ui.Footer.show());
    // this.props.Dispatch(Middleware.Ui.Header.show());
  }

  private onSubmitHandler(event: React.FormEvent<HTMLFormElement>): void {
    const query = document.location.search;
    const params = new URLSearchParams(query);
    const redirecturl = params.get("redirecturl");

    event.preventDefault();
    this.props.Dispatch(
      Middleware.Auth.signin(this.state.signin, async () => {
        // Login success
        const profile = await Middleware.Profile.load();

        // console.log(
        //   "юзер зареган на воркшопе?",
        //   this.props.Store.Auth.isExistedWorkshopUser
        // );

        await Middleware.Schedule.section(+process.env.SCHEDULE_ID, this.props.Store.Networking.Days.data);

        await Middleware.Schedule.sectionList();

        if (redirecturl !== null) {
          document.location.href = redirecturl;
          return;
        }

        if (
          !this.props.Store.Auth.isExistedWorkshopUser ||
          (!profile.isEnabledSubscribeToAllWebinars &&
            !Cookie.get("isShowedPagePlan2"))
        ) {
          this.props.history.push("/auth/plan");
          return;
        }

        if (
          this.state.workshopRegistrationDate >
          moment(profile.updatedAt).tz("Europe/Moscow")
        ) {
          this.props.history.push("/auth/confirm/profile");
          return;
        } else if (profile.useNetworking === null) {
          this.props.history.push("/auth/networking");
          return;
        } else {
          this.props.history.push(this.props.Store.Auth.preurl);
        }
      })
    );
  }

  private onChangeHandler(event: React.ChangeEvent<HTMLInputElement>): void {
    this.setState({
      signin: { ...this.state.signin, [event.target.name]: event.target.value },
    });
  }

  public render() {
    return (
      <div className="auth auth--signin">
        <div className="auth__wrapper auth__wrapper--big">
          <div className="auth__header">
            <h1>Авторизация</h1>
          </div>
          <form onSubmit={this.onSubmitHandler}>
            <div className="form__group form__group--margin">
              <div className="auth__pwd">
                <label className="visually-hidden" htmlFor="login">
                  Ваш email*
                </label>
                <div className="auth__pwd-input">
                  <input
                    className="input"
                    type="email"
                    name="login"
                    id="login"
                    value={this.state.signin.login}
                    onChange={this.onChangeHandler}
                    placeholder="Е-mail"
                    required={true}
                    autoComplete="username"
                  />
                </div>
                <label />
              </div>
              <div className="auth__pwd">
                <label className="visually-hidden" htmlFor="password">
                  Ваш пароль*
                </label>
                <div className="auth__pwd-input">
                  <input
                    className="input"
                    type={this.state.isPwdShowed ? "text" : "password"}
                    name="password"
                    id="password"
                    value={this.state.signin.password}
                    onChange={this.onChangeHandler}
                    placeholder="Введите пароль"
                    required={true}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    aria-label={
                      this.state.isPwdShowed
                        ? "Скрыть пароль"
                        : "Показать пароль"
                    }
                    className={`auth__pwd-btn ${
                      this.state.isPwdShowed ? "" : "auth__pwd-btn--closed"
                    }`}
                    onClick={() => {
                      this.setState({ isPwdShowed: !this.state.isPwdShowed });
                    }}
                  />
                </div>
                <label />
              </div>
              <div className="auth__pwd-restore">
                <div>Забыли пароль?&nbsp;</div>
                <Link to="/auth/password/restore">Восстановить</Link>
              </div>
            </div>

            <div className="auth__footer">
              <button className="auth__btn btn btn--blue" type="submit">
                Войти на сайт
              </button>

              <div className="auth__pwd-restore">
                <div>Нет еще аккаунта? &nbsp;</div>
                <Link to="/auth/signup">Зарегистрируйтесь</Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default connect(
  (Store: any) => {
    return { Store };
  },
  (Dispatch: (action: any) => void) => {
    return { Dispatch: (action: any) => Dispatch(action) };
  }
)(SignInPage);
